import { Link } from 'react-router-dom';
import {
  DEMO_COMING_SOON,
  DEMO_COMING_SOON_MESSAGE,
  ROUTES,
} from '@/constants/site';

/**
 * 내부 링크. 준비 중인 Demo 로 향하면 이동을 막고 안내만 띄운다.
 * 데모 화면이 확정되면 constants/site.js 의 DEMO_COMING_SOON 만 끄면 된다.
 */
export function SiteLink({ to, onClick, children, ...rest }) {
  const blocked = DEMO_COMING_SOON && to === ROUTES.demo;

  const handleClick = (event) => {
    if (blocked) {
      event.preventDefault();
      window.alert(DEMO_COMING_SOON_MESSAGE);
      return;
    }
    onClick?.(event);
  };

  return (
    <Link
      to={to}
      onClick={handleClick}
      {...(blocked ? { 'aria-disabled': 'true' } : null)}
      {...rest}
    >
      {children}
    </Link>
  );
}
